import { render, staticRenderFns } from "./VendorSelection.vue?vue&type=template&id=2035cdf8&"
import script from "./VendorSelection.vue?vue&type=script&lang=js&"
export * from "./VendorSelection.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VAvatar,VIcon,VItem,VItemGroup})
